var map = {
	"./BlockComponent.vue": "a327",
	"./ContactFormDe.vue": "83e5",
	"./ContactFormEn.vue": "59fd",
	"./ContactFormPl.vue": "4bb5",
	"./ContactSection.vue": "642d",
	"./GrayBanner.vue": "31d3",
	"./Intro.vue": "de4e",
	"./Posts.vue": "95f2",
	"./SmallBlueTiles.vue": "ddbd",
	"./TextAndImage.vue": "d831",
	"./TwoTiles.vue": "f8df"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3f3f";